module.exports = __webpack_public_path__ + "img/upper ruffle length.46644a6e.png";